import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PageHero } from '../components/ui/PageHero';
import { CtaBanner } from '../components/CtaBanner';
import { caseStudies, caseStudyCategories } from '../data/caseStudies';
import { images } from '../data/images';
import { EASE_OUT } from '../utils/motion';
export function CaseStudies() {
  const [filter, setFilter] = useState('Tous');
  const visible = filter === 'Tous' ? caseStudies : caseStudies.filter(c => c.category === filter);
  return <>
      <PageHero label="Références" title="Des missions concrètes, des gains vérifiés." description="Quelques exemples de missions récentes. Par confidentialité, les noms des clients ne sont pas communiqués." image={images.warehouse} data-id="element-533" data-mp="3bwbaliql2pii" />

      <section className="bg-paper py-20 lg:py-28" data-id="element-534" data-mp="1mh3ebv8s893t">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-535" data-mp="1mkitey2ghi58">
          <div className="flex flex-wrap gap-2" role="group" aria-label="Filtrer par domaine" data-id="element-536" data-mp="1qlb7c4m9wb7u">
            {caseStudyCategories.map(cat => <button key={cat} type="button" onClick={() => setFilter(cat)} aria-pressed={filter === cat} className={`relative rounded-lg px-4 py-2 text-sm transition-colors duration-150 ${filter === cat ? 'text-white' : 'text-ink hover:bg-ink/[0.06]'}`} data-id="element-537" data-mp="3fg9gfxwyq4p">
                {filter === cat && <motion.span layoutId="case-filter" className="absolute inset-0 rounded-lg bg-ink" transition={{
              duration: 0.25,
              ease: EASE_OUT
            }} data-id="element-538" data-mp="meu4l17dq6ws" />}
                <span className="relative" data-id="element-539" data-mp="w3vpn5ss7ehm">{cat}</span>
              </button>)}
          </div>

          <motion.div layout className="mt-12 space-y-6" data-id="element-540" data-mp="1a3de1k260pqg">
            <AnimatePresence mode="popLayout" initial={false} data-id="element-541" data-mp="1a3wm8920jzra">
              {visible.map(cs => <motion.article key={cs.slug} layout initial={{
              opacity: 0,
              y: 16
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              scale: 0.98
            }} transition={{
              duration: 0.25,
              ease: EASE_OUT
            }} className="grid gap-8 rounded-[28px] bg-white p-3 lg:grid-cols-12" data-id="element-542" data-mp="152h16gzu5t8w">
                  <div className="aspect-[4/3] overflow-hidden rounded-[22px] lg:col-span-4 lg:aspect-auto" data-id="element-543" data-mp="gkdhh1mkjxy6">
                    <img src={cs.image} alt="" className="h-full w-full object-cover" data-id="element-544" data-mp="qgq97tyk01qa" />
                  </div>
                  <div className="p-4 lg:col-span-8 lg:py-8 lg:pr-8" data-id="element-545" data-mp="vg2vodlij6sc">
                    <div className="flex flex-wrap gap-2 text-sm" data-id="element-546" data-mp="vdozg1f3joj7">
                      <span className="rounded-md bg-ink px-2.5 py-1 text-white" data-id="element-547" data-mp="zg3mkxpstaga">{cs.category}</span>
                      <span className="rounded-md bg-ink/[0.06] px-2.5 py-1" data-id="element-548" data-mp="2x8hj1s6tt3g5">{cs.client}</span>
                      <span className="rounded-md bg-ink/[0.06] px-2.5 py-1" data-id="element-549" data-mp="319jctthz4naq">{cs.duration}</span>
                    </div>
                    <h2 className="mt-5 text-[clamp(1.4rem,2.4vw,2rem)] font-medium leading-tight tracking-tight" data-id="element-550" data-mp="2tqju7q2c6zsf">{cs.title}</h2>
                    <div className="mt-6 grid gap-8 md:grid-cols-2" data-id="element-551" data-mp="2jzfgetoedkz6">
                      <div data-id="element-552" data-mp="2jzp94p0tu68k">
                        <h3 className="text-sm font-medium text-muted" data-id="element-553" data-mp="2fxu3577yb4og">Le défi</h3>
                        <p className="mt-2 leading-relaxed" data-id="element-554" data-mp="2fw0wvt192mgz">{cs.challenge}</p>
                      </div>
                      <div data-id="element-555" data-mp="3clqmukyoqg3w">
                        <h3 className="text-sm font-medium text-muted" data-id="element-556" data-mp="37oi2qetz8200">Les actions</h3>
                        <ul className="mt-2 space-y-1.5" data-id="element-557" data-mp="33n6diaf0lisc">
                          {cs.actions.map(a => <li key={a} className="flex gap-3 leading-relaxed" data-id="element-558" data-mp="2yov6e7g3tmdt">
                              <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brass" aria-hidden="true" data-id="element-559" data-mp="1s7zuz2yku4aj" />
                              {a}
                            </li>)}
                        </ul>
                      </div>
                    </div>
                    <dl className="mt-8 flex flex-wrap gap-10 border-t border-ink/10 pt-6" data-id="element-560" data-mp="3fwky2yshihya">
                      {cs.results.map(r => <div key={r.label} data-id="element-561" data-mp="3267sh332ffc4">
                          <dt className="sr-only" data-id="element-562" data-mp="323d6h74elmgl">{r.label}</dt>
                          <dd className="text-3xl font-medium text-brass-dark" data-id="element-563" data-mp="367ktmzv7qucp">{r.value}</dd>
                          <dd className="text-sm text-muted" data-id="element-564" data-mp="3txnm3h31i2bu">{r.label}</dd>
                        </div>)}
                    </dl>
                  </div>
                </motion.article>)}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      <CtaBanner data-id="element-565" data-mp="3ptfsb5hq5w6r" />
    </>;
}